// extracted by mini-css-extract-plugin
export default {"root":"PageThemes_root__79AV0","top":"PageThemes_top__2mdkn"};